import React from "react";

interface Props {
  name?: string;
  value: string | number;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  touched?: boolean;
  label?: string;
  showRequired?: boolean;
  characterLimit?: number;
  classNameLabel?: string;
  disabled?: boolean;
  type?: string;
  className?: string;
  icon?: string;
  endIcon?: any;
  rightElement?: React.ReactNode;
  width?: string;
  displaynone?: boolean;
  labelCheckbox?: boolean;
  labelCheckboxChecked?: boolean;
  onLabelCheckboxChange?: (checked: boolean) => void;
  disableLabelCheckbox?: boolean;
  readOnlyMode?: boolean;
  style?: React.CSSProperties; // style applied to the input element
  autoFocus?: boolean;
}

export const TextInput: React.FC<Props> = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  touched,
  showRequired,
  label,
  characterLimit,
  disabled,
  type = "text",
  className,
  icon,
  endIcon,
  classNameLabel,
  rightElement,
  width,
  displaynone,
  labelCheckbox = false,
  labelCheckboxChecked,
  onLabelCheckboxChange,
  disableLabelCheckbox,
  readOnlyMode = false,
  style,
  autoFocus,
  ...props
}) => {
  return (
    <div
      className={`${width ? width : ""} ${
        displaynone ? "d-none" : ""
      } ${className}`}
    >
      <div className="d-flex mb-1 align-items-center gap-2 justify-content-between w-100">
        <div className="d-flex gap-2">
          {labelCheckbox && !readOnlyMode && (
            <input
              type="checkbox"
              checked={labelCheckboxChecked}
              onChange={(e) => onLabelCheckboxChange?.(e.target.checked)}
              className="me-2"
              style={{ cursor: "pointer" }}
              disabled={disableLabelCheckbox}
            />
          )}
          <label
            htmlFor={name}
            className={`form-label ${classNameLabel}`}
            style={{
              left: 0,
              top:
                classNameLabel && classNameLabel.includes("top-25")
                  ? "-25px"
                  : classNameLabel && classNameLabel.includes("top-35")
                  ? "-35px"
                  : classNameLabel
                  ? "-10px"
                  : "",
            }}
          >
            {label}
            {showRequired && <small className="required ms-1">*</small>}
          </label>
          {characterLimit && typeof value === "string" && (
            <label
              className={
                value.trim().length > characterLimit
                  ? "text-danger"
                  : "text-muted"
              }
            >
              ({value.trim().length}/{characterLimit}
              {type === "text" ? "" : " digits"})
            </label>
          )}
        </div>
        {rightElement && <>{rightElement}</>}
      </div>

      <div className="input-group">
        {icon && (
          <span className="input-group-text bg-transparent">
            <i className={`bi bi-${icon}`}></i>
          </span>
        )}
        <input
          type={type}
          className={`form-control ${error && touched ? "is-invalid" : ""}`}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          style={style}
          autoFocus={autoFocus}
          {...props}
        />
        {endIcon && (
          <span className="input-group-text bg-transparent">
            {typeof endIcon === "string" ? <i className={endIcon} /> : endIcon}
          </span>
        )}
      </div>

      {touched && error && (
        <div className="invalid-feedback d-block">{error}</div>
      )}
    </div>
  );
};

export default TextInput;
